/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutState } from './rolloutState';
import { RolloutTargetType } from './rolloutTargetType';
import { RolloutTargetTenantSummary } from './rolloutTargetTenantSummary';
import { RolloutType } from './rolloutType';
import { RolloutTenantExecutionSpec } from './rolloutTenantExecutionSpec';


export interface RolloutTenantSummary { 
    /**
     * Name of the rollout.
     */
    name?: string;
    /**
     * Description of the rollout.
     */
    description?: string;
    state?: RolloutState;
    type?: RolloutType;
    target_type?: RolloutTargetType;
    rollout_execution_spec?: RolloutTenantExecutionSpec;
    targets?: Array<RolloutTargetTenantSummary>;
}
export namespace RolloutTenantSummary {
}


